import React, { useState } from 'react';

export function TextArea({
  label,
  requiredField,
  charCount,
  maxCount,
  placeHolder,
  fromForm,
  duplicatingItem,
  index,
  i,
  id,
  eleIndex,
  elekey,
  disable,
  value,
  editingInput,
  showDelete,
  deleteItem,
  onChange,
  elementId,
  fromCustomSection,
}) {
  const [isOver, setIsOver] = useState(false);

  const mouseOver = () => {
    setIsOver(true);
  };
  const mouseOut = () => {
    setIsOver(false);
  };

  const handleDuplicateItem = () => {
    fromCustomSection ? duplicatingItem(index, i, elementId, fromCustomSection) : duplicatingItem(index, i, elekey);
    setIsOver(false);
  };

  return (
    <div className="input-group input-floating-label fixed-label remove-border-text-box" onMouseEnter={mouseOver} onMouseLeave={mouseOut}>
      <label className={`asterisk-req ${fromForm && 'd-flex'}`}>
        {label}
        {requiredField && <span>*</span>}
      </label>
      <textarea
        name={label}
        id={label}
        key={`_${eleIndex}_${i}_${index}`}
        rows={4}
        disabled={disable}
        placeholder={placeHolder}
        onChange={(e) => onChange(e.target.value, label, i, eleIndex, index)}
        value={value}
      />
      {fromForm && isOver && (
        <div className="potemp-action-btns">
          <button
            type="button"
            className="btn btn-border ml-auto  py-0 px-1"
            key={`_${eleIndex}_${i}_${index}_edit`}
            onClick={() => editingInput(index, i, eleIndex)}
          >
            <span className="icon-edit" />
          </button>
          {showDelete && isOver && (
            <button
              type="button"
              className="btn btn-border  py-0 px-1"
              key={`_${eleIndex}_${i}_${index}_delete`}
              onClick={() => deleteItem(index, i, elekey, eleIndex)}
            >
              <span className="icon-delete" />
            </button>
          )}
          <button type="button" className="btn btn-border  py-0 px-1" key={`_${eleIndex}_${i}_${index}_duplicate`} onClick={() => handleDuplicateItem()}>
            <span className="icon-copy" />
          </button>
        </div>
      )}
      {charCount && (
        <div key={`_${eleIndex}_${i}_${index}`} className="text-count">
          0/{maxCount}
        </div>
      )}
    </div>
  );
}
export default TextArea;
